// import React from "react"
// import ReactDOM from "react-dom"
// import App from "./App"
// import * as serviceWorker from "./serviceWorker"
// import { BrowserRouter } from "react-router-dom"
// import { Provider } from "react-redux"

// import store from "./store"

// const app = (
//   <Provider store={store}>
//     <BrowserRouter>
//       <App />
//     </BrowserRouter>
//   </Provider>
// )
// ReactDOM.render(app, document.getElementById("root"))
// serviceWorker.register()

import React from "react"
// import { createRoot } from "react-dom/client"; // ✅ Use this for React 18
import App from "./App"
import * as serviceWorker from "./serviceWorker"
import { BrowserRouter } from "react-router-dom"
import { Provider } from "react-redux"
import ReactDOM from "react-dom"

import store from "./store"

const container = document.getElementById("root")
// const root = createRoot(container); // ✅ React 18 compatible

const app = (
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
)
ReactDOM.render(app, document.getElementById("root"))
serviceWorker.register()
